import React, {useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import "../App.css";
import Back from "../Components/back";
import Level1 from "../Assets/level1.png";
import Level2 from "../Assets/level2.png";
import Level3 from "../Assets/level3.png";
import Level4 from "../Assets/level4.png";
import Swal from "sweetalert2";
import level from "../Api/level";


export default function Levels() {
  const [levelData, setLevelData] = useState(null);
  const navigate = useNavigate();

  const Toast = Swal.mixin({
    toast: true,
    position: 'bottom-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })

  const fetchLevelInfo = async () => {
    try {
      const response = await level();
      setLevelData(response.data);
    } catch (error) {
      console.error("API Error:", error.message);
      if (error.response.status === 401 || error.response.status === 500 || error.response.status === 500) {
        Toast.fire({
          icon: 'error',
          title: error.response.data.title
        })
        localStorage.clear();
        navigate("/");
      }
      Toast.fire({
        icon: 'error',
        title: error.response.data.message
      })
    }
  };

  useEffect(() => {
    fetchLevelInfo()
  }, []);

  console.log('levelData',levelData)


  return (
    <>
      <div className="container mobile-page">

        <div className="container">
          <div className="row">
            <div className="col-2 d-flex align-items-center">
              <Back />
            </div>
            <div className="col-8 text-center">
              <span className="fs-3 text-white fw-bold">VIP Level</span>
            </div>
          </div>
        </div>

        {levelData?.vipLevelList && levelData?.vipLevelList.map((item, index) => (
            <div className="mt-4 px-3 py-4 rounded-4 light-black">
              <div className="row">
                <div className="col-4 badge-image">
                  <img src={item.imageUrl}  alt='level1'/>
                </div>
                <div className="col-8 d-flex flex-column">
                  <div className='mb-2'>
                    <div className="row">
                      <div className="col-7">
                        <span className="fw-bold  text-white h6">{item.lvlDesc}</span>
                      </div>
                      {
                        item.currentVipLevel && (
                              <div className="col-5">
                                <button className='button-outline rounded-5 px-1 py-1 text-white pending' style={{ fontSize: '12px' }}>
                                  <span className='fw-bold'>Current</span>
                                </button>
                              </div>
                          )
                      }
                    </div>

                  </div>
                  <span className='lightGrey' style={{fontSize:'13px'}}
                        dangerouslySetInnerHTML={{
                          __html: item.remark,
                        }}/>
                </div>
              </div>
            </div>
          )
        )}
      </div>
    </>
  );
}
